import Mun from "./Mun"

class Tie extends Mun {
}

export default Tie
